const nameValidator = (value, t) => {
  if (value.length === 0) {
    return t('empty.invalid')
  }

  if (value.length <= 2) {
    return t('name.invalid.short')
  }

  if (value.length >= 50) {
    return t('name.invalid.long')
  }

  return null;
};

const requiredValidator = (value, t) => {
  if (value.length === 0) {
    return t('empty.invalid')
  }

  return null
};

const organizationValidator = (value, t) => {
  if (value.length === 0) {
    return t('empty.invalid')
  }

  if (value.length >= 50) {
    return t('company.invalid')
  }

  return null;
};

const profileNameValidator = (value, t) => {
  if (value.length === 0) {
    return t('empty.invalid')
  }

  if (value.length >= 50) {
    return t('name.invalid')
  }

  return null;
};

const emailValidator = (value, t) => (/^\S+@\S+$/.test(value) ? null : t('email.invalid'));

const passwordValidator = (value, { password }, t) => {
  if (value.length === 0) return t('empty.invalid');
  
  return value === password ? null : t('passwordAgain.invalid');
}

const mainPasswordValidater = (value, t) => {
  if (value.length === 0) return t('empty.invalid');

  if (value.length < 6 || value.search(/^.*[А-ЯA-Z]{1}.*$/) === -1) {
    return t('password.validation.fail')
  }

  return null;
}

const linkValidator = (value, t) => {
  if (value.length === 0) return t('empty.invalid');

  const regexp = /^(https?\:\/\/)?(maps\.app\.goo\.gl|www\.google\.com)\/.+$/

  return regexp.test(value) ? null : t('link.invalid');
}

export {
  linkValidator,
  nameValidator,
  profileNameValidator,
  organizationValidator,
  emailValidator,
  mainPasswordValidater,
  passwordValidator,
  requiredValidator
}